module.exports = __webpack_public_path__ + "static/media/Visto.41baaeca.svg";